import { Scene } from 'phaser';
import { TweenAction } from './TweenAction';

export class DisplaySizeAction extends TweenAction {
  protected displayWidth: number;
  protected displayHeight: number;

  constructor(scene: Scene, targets: any, duration: number, displayWidth: number, displayHeight: number) {
    super(scene, targets, duration);
    this.displayWidth = displayWidth;
    this.displayHeight = displayHeight;
  }

  protected setTweenConfig() {
    super.setTweenConfig();
    this.setTweenConfigValue('displayWidth', this.displayWidth);
    this.setTweenConfigValue('displayHeight', this.displayHeight);
  }
}